"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LandlordsIntro() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = ["Comprehensive full-home structural assessments", "Certified wind mitigation for insurance savings", "Detailed 4-point inspections for older homes", "Advanced sewer scope and mold testing options"];
  return <section data-section-id="244310" id="overview" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="relative rounded-lg overflow-hidden shadow-xl group">
            <div className="absolute inset-0 bg-primary/5 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/miami_dade_county_map_inspection.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/miami_dade_county_map_inspection.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/miami_dade_county_map_inspection.png-wvc-sizes" alt="Miami-Dade County service area map for home inspections" className="w-full h-auto object-cover aspect-[4/3] transform group-hover:scale-105 transition-transform duration-700" loading="lazy" />
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h2 className="text-secondary font-default text-2xl md:text-[24px] leading-tight font-bold tracking-tight">
              Miami-Dade Inspection Experts
            </h2>
            
            <p className="text-foreground/90 text-lg leading-relaxed font-default">
              From the vibrant streets of Miami to the quiet suburbs of Homestead, we provide the most thorough home inspections in South Florida. Our local expertise ensures your property meets all Florida building codes and insurance requirements.
            </p>

            <ul className="space-y-4 mt-2">
              {features.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                  <span className="text-foreground/80 font-default text-base md:text-lg">{item}</span>
                </li>)}
            </ul>

            <div className="pt-6">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base px-8 h-12 rounded-md shadow-md">
                <Link to="https://trusted-fl.com/#our-inspection-services">
                  View County Services
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}